
@switch (type) {
  @case ('facebook') {
    <div class="d-inline">
      <button (click)="signInWithFB()" class="btn btn-block btn-facebook text-uppercase" [disabled]="progress">
        @if (!progress) {
          <i class="fab fa-facebook"></i>
          } Facebook
          @if (progress) {
            <span><i class="fas fa-asterisk fa-spin"></i></span>
          }
        </button>
      </div>
    }
    @case ('google') {
      <div class="d-inline">
        <div [attr.id]="'buttonDiv' + idName" style="position: relative; top: -3px; width: min-content"></div>
        <!-- <button
        (click)="signInWithGoogle()"
        class="btn btn-block btn-light text-uppercase"
        [class.btn-white]="!isMobile"
        [disabled]="progress"
        >
        <i *ngIf="!progress" class="fab fa-google"></i> Google
        <span *ngIf="progress"><i class="fas fa-asterisk fa-spin"></i></span>
      </button> -->
    </div>
  }
}
@if (signError) {
  <p class="text-danger">{{ 'web.social_signin_error' | translate }}</p>
}
@if (signError2) {
  <p class="text-danger">{{ 'web.form_unique_device_error' | translate }}</p>
}
